import * as s from "styles/ModalCommonStyled";
import { ValidateWord } from "components/atoms/text/Text";
import UserGroupRecorder from "components/element/search/userGroupRecorder/UserGroupRecorder";
import {
  UserGroupCURequest,
  UserGroupCUSystem,
} from "api/interfaces/userInterface.interface";
import { UPDATE_TYPE } from "../AddUserGroupContainer";

interface RecordersStepPageProps {
  accountId: string;
  isAdminGroup: boolean;
  isNoRecorder: boolean;
  isSelectionDisabled: boolean;
  isDisabledAutoApply: boolean;
  recorderValidate: boolean;
  recorderValidateMsg: string;
  madeUserGroupUserId: string;
  userGroup: UserGroupCURequest;
  onChangeGroupInfo: (type: UPDATE_TYPE, value: any) => void;
}

export default function RecordersStepPage(
  props: RecordersStepPageProps
): JSX.Element {
  return (
    <>
      <s.CheckInput>
        <input
          type="checkbox"
          defaultChecked={props.userGroup.autoApplyRecorder}
          checked={props.userGroup.autoApplyRecorder}
          onChange={(e) =>
            props.onChangeGroupInfo(UPDATE_TYPE.AUTO_APPLY, e.target.checked)
          }
          disabled={
            props.isDisabledAutoApply ||
            (props.isNoRecorder && props.userGroup.autoApplyRecorder)
          }
          data-testid="users-usersgroup-input-auto-apply-recorder"
        />
        Apply to all current and future Recorders.
      </s.CheckInput>
      {props.isNoRecorder && props.isAdminGroup && (
        <ValidateWord data-testid="users-usersgroup-validate-auto-apply-recorder">
          This organization has no recorders, so you need to apply all.
        </ValidateWord>
      )}

      <s.ModalTableContainer>
        {!(
          props.userGroup.userPermission.enableAllPermissions ||
          props.userGroup.autoApplyRecorder
        ) && (
          <UserGroupRecorder
            accountId={props.accountId}
            selectedRow={props.userGroup.systems}
            selectedGroupRow={props.userGroup.recorderGroups}
            onSelectedRowsChange={(value) =>
              props.onChangeGroupInfo(UPDATE_TYPE.RECORDERS, value)
            }
            onChangeCamera={(value: UserGroupCUSystem) =>
              props.onChangeGroupInfo(UPDATE_TYPE.RECORDER_CAMEARS, value)
            }
            onSelectedGroupRowsChange={(value: number[]) =>
              props.onChangeGroupInfo(UPDATE_TYPE.RECORDER_GROUPS, value)
            }
            userId={props.madeUserGroupUserId}
            isDisabled={props.isSelectionDisabled}
          />
        )}
      </s.ModalTableContainer>

      {!props.userGroup.autoApplyRecorder &&
        props.recorderValidate &&
        props.recorderValidateMsg && (
          <ValidateWord data-testid="users-usersgroup-validate-recorder">
            {props.recorderValidateMsg}
          </ValidateWord>
        )}
    </>
  );
}
